import { makeRequest, CommonRequestOptions } from '../makeRequest';
import { SkillRatingConstituents } from '~/monolith-api';

export type CourseSkillsAssignee = {
   assigneeid: number;
   assigneetype: string;
   name: string;
   average_skill_rating: number;
   constituents: SkillRatingConstituents;
};

export type GetAssigneesSkilledInACourseResponse = {
   assignees: CourseSkillsAssignee[];
   hasMore: boolean;
};

export type GetAssigneesSkilledInACourseOptions = CommonRequestOptions & {
   query?: string;
   order?: 'DESC' | 'ASC';
   offset?: number;
   limit?: number;
};

export function getAssigneesSkilledInACourse(
   wikiid: number,
   { query, order, offset, limit, ...common }: GetAssigneesSkilledInACourseOptions = {}
): Promise<GetAssigneesSkilledInACourseResponse> {
   return makeRequest('get', `/skills/courses/${wikiid}/assignees`, {
      ...common,
      query: {
         query,
         order,
         offset,
         limit,
      },
   });
}
